/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CollectionModelUserRoleResponseModel } from '../../models/collection-model-user-role-response-model';

export interface GetRoles$Params {
  userId: string;
}

export function getRoles(http: HttpClient, rootUrl: string, params: GetRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectionModelUserRoleResponseModel>> {
  const rb = new RequestBuilder(rootUrl, getRoles.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CollectionModelUserRoleResponseModel>;
    })
  );
}

getRoles.PATH = '/users/{userId}/roles';
